<template>
	<ul class="wp-navi-links" :class="[{ 'has-active-items': anySubIsActive(menu) }, naviClass]">
		<li
			class="link-list"
			v-for="(item, i) in menu"
			:key="i"
			:class="[
				{ 'has-childs': item.children && item.children[0] },
				{ 'list-link-active': subIsActive(item.url) },
			]"
		>
			<WpLink
				:url="item.url"
				:id="item.id"
				:title="item.title"
				:classname="[item.class, 'link-navi', linkClass]"
				:target="item.target"
				:type="item.type"
				:ref="'menu-link-' + i"
			>
				{{ item.title.replace('#038;', '') }}
			</WpLink>
			<wp-navi-links
				v-if="item.children && item.children[0]"
				:menu="item.children"
				:parent="item.ID"
				:link-class="linkClass"
				:depth="menuDepth"
				:class="{ 'has-link-active': subIsActive(item.url) }"
			/>
		</li>
	</ul>
</template>

<script>
import WpLink from '@/components/elements/WpLink'
import WpNaviLinks from '@/components/elements/WpNaviLinks'

import { mapGetters } from 'vuex'

export default {
	name: 'wp-navi-links',
	props: ['menu', 'parent', 'depth', 'linkClass'],
	components: {
		WpLink,
		'wp-navi-links': WpNaviLinks,
	},
	mounted: function () {
		//this.checkAct();

		const refs = this.$refs
		const VM = this
		for (var key in refs) {
			// skip loop if the property is from prototype
			if (!refs.hasOwnProperty(key)) continue

			var obj = refs[key]
			for (var prop in obj) {
				// skip loop if the property is from prototype
				if (!obj.hasOwnProperty(prop)) continue
				//console.log(obj[prop].$el)
				VM.observer[key] = new MutationObserver((mutations) => {
					for (const m of mutations) {
						const newValue = m.target.getAttribute(m.attributeName)
						VM.$nextTick(() => {
							VM.onClassChange(newValue, m.oldValue)
						})
					}
				})
				VM.observer[key].observe(obj[prop].$el, {
					attributes: true,
					attributeOldValue: true,
					attributeFilter: ['class'],
				})
			}
		}
	},
	data() {
		return {
			homeUrl: window.WPVUE.home_url,
			hasActiveChild: false,
			items: [],
			observer: [],
			test: false,
		}
	},
	methods: {
		onClassChange(newValue, oldValue) {
			//console.log({oldValue, newValue})
			//console.log(this.test = newValue.includes('router-link-active'))
		},
		anySubIsActive(menu) {
			let test = []
			const VM = this
			if (menu) {
				menu.forEach((element) => {
					test.push(VM.subIsActive(element.url))
				})
			}
			let test2 = test.some((val) => {
				return val
			})
			return test2
		},
		subIsActive(input) {
			if (input === '/' || input === this.homeUrl + '/' || input === this.homeUrl) return false
			const VM = this
			const paths = Array.isArray(input) ? input : [input]
			const test = paths.some((path) => {
				let url = this.$route.path.replace(this.homeUrl, '').replace(/\/$/, '')
				let path2 = path.replace(this.homeUrl, '').replace(/\/$/, '')
				return url.indexOf(path2) === 0 // current path starts with this path string
			})
			//this.$emit('hasActive', test);
			return test
		},
	},
	watch: {
		hasActiveChild(val) {
			this.$emit('isChanged', val)
		},
	},
	computed: {
		menuDepth() {
			let depth = 1
			if (this.depth) {
				depth = depth + Number(this.depth)
			}
			return depth
		},
		naviClass() {
			let classNames = ''
			if (this.menuDepth === 1) classNames += 'top-level level-1'
			if (this.menuDepth && this.menuDepth !== 1) classNames += 'level-' + this.menuDepth
			if (this.parent) {
				classNames += ' has-parent parent-' + this.parent
			}
			return classNames
		},
	},
	beforeDestroy() {
		this.observer.forEach((obs) => {
			obs.disconnect()
		})
	},
}
</script>
